import { useMemo } from 'react';
import { useCurrentUser } from '@hotjar/user';
import { useCurrentSite } from '@hotjar/site';
import { getOAuthURL } from '@hotjar/webapp/domains/activation/gtm/api';
import { useSettings } from '@hotjar/webapp/hooks/useSettings';

export const useGtmOAuthUrl = (): string => {
  const { data: currentSite } = useCurrentSite();
  const { data: user } = useCurrentUser();
  const { data: settings } = useSettings();
  const gtmOAuthURL = useMemo(() => {
    if (currentSite && user && settings) {
      return getOAuthURL(currentSite, user, settings);
    }
    return '';
  }, [currentSite, user, settings]);
  return gtmOAuthURL;
};
